if(!customElements.get('facets-component')) {
  customElements.define(
    'facets-component',
    class FacetsComponent extends HTMLElement {
      #sortEl;
      #onChange;

      constructor() {
        super();
      }

      connectedCallback() {
        this.#sortEl = this.querySelector('[name="sort_by"]');
        if(!this.#sortEl) return;

        this.#onChange = this.#emitEvent.bind(this);
        this.#sortEl.addEventListener('change', this.#onChange);
      }

      disconnectedCallback() {
        this.#sortEl?.removeEventListener('change', this.#onChange);
      }

      #emitEvent() {
        const event = new CustomEvent('query:change', {
          bubbles: true
        });
        this.dispatchEvent(event);
      }
    }
  )
}